export const DATA_TEST = 'dataTest';
export const DATA_TEST_ATTR = 'data-test';
export const DATA_GTM = 'dataGtmClick';
export const DATA_GTM_ATTR = 'data-gtm-click';
export const DATA_MBT = 'dataMbtClick';
export const DATA_MBT_ATTR = 'data-mbt-click';
export const DATA_GTM_VIEW = 'dataGtmView';
export const DATA_GTM_VIEW_ATTR = 'data-gtm-view';
export const buildDataAttr = (() => {
    const data = [
        [DATA_TEST, DATA_TEST_ATTR],
        [DATA_GTM, DATA_GTM_ATTR],
        [DATA_MBT, DATA_MBT_ATTR],
        [DATA_GTM_VIEW, DATA_GTM_VIEW_ATTR],
    ];
    return function (props, defaultDataProps) {
        const defProps = defaultDataProps || {};
        return data.reduce((curr, [compAttr, tagAttr]) => {
            const value = props[compAttr] || defProps[compAttr];
            return !!value ? Object.assign(Object.assign({}, curr), { [tagAttr]: value }) : curr;
        }, {});
    };
})();
